import React, {Component} from "react";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronLeft,
    faCog,
    faEdit,
    faFilter,
    faInfo,
    faPlus,
    faSearch,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faTimes,
    faUser,
    faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import Header from "./common/Header/Header";
import Sidebar from "./common/Sidebar/Sidebar";
import "./App.css";
import "@babel/polyfill";

library.add(
    far,
    faUserCircle,
    faSignOutAlt,
    faEdit,
    faInfo,
    faSort,
    faSortUp,
    faSortDown,
    faSearch,
    faFilter,
    faChevronLeft,
    faCog,
    faUser,
    faPlus,
    faTimes,
  faCheck,
  faCaretDown,
  faCaretUp
);

class App extends Component {
  render() {
    return (
      <div className="Layout">
        <Header auth={this.props.auth} />

        <div className="layout-wrapper">
          <Sidebar location={this.props.location} />
          <div className="Layout-body">
            <div className="Layout-content">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js